import * as Ably from 'ably';

import { apiRoutes, getApiUrl } from '@/constants/api';

class AblyClient {
  private static instance: Ably.Realtime | null = null;

  private constructor() {}

  public static getInstance(): Ably.Realtime | null {
    if (typeof window === 'undefined') {
      return null;
    }

    if (!AblyClient.instance) {
      AblyClient.instance = new Ably.Realtime({
        authMethod: 'GET',
        authHeaders: {
          'Content-Type': 'application/json',
          credentials: 'include',
        },
        authParams: {},
        transportParams: {
          withCredentials: true,
        },
        closeOnUnload: true,
        authCallback: async (tokenParams, callback) => {
          try {
            const response = await fetch(getApiUrl(apiRoutes.ably.getToken), {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              },
            });

            if (!response.ok) {
              const errorText = await response.text();
              console.error(
                'Token request failed:',
                response.status,
                errorText,
              );
              callback(`HTTP ${response.status}: ${errorText}`, null);
              return;
            }

            const tokenRequest = await response.json();
            callback(null, tokenRequest);
          } catch (error) {
            console.error('Auth callback error:', error);
            callback(error as Ably.ErrorInfo, null);
          }
        },
      });
    }
    return AblyClient.instance;
  }

  public static reset(): void {
    if (AblyClient.instance) {
      AblyClient.instance.close();
      AblyClient.instance = null;
    }
  }
}

export default AblyClient;
